import {
  createApi,
  defaultSerializeQueryArgs,
} from '@reduxjs/toolkit/query/react';

import { Tags } from '~/api/unified-fields/tags.autogen';

import { extractRtkQueryRehydrationInfo } from '../rehydrate';
import { TagType } from '../TagType';
import { extractQueryOptions } from '../utils';
import { unifiedFieldsBaseQuery } from './baseQuery';

export const UNIFIED_FIELDS_API_REDUCER_PATH = 'api/unified-fields' as const;

export const unifiedFieldsApiRoot = createApi({
  reducerPath: UNIFIED_FIELDS_API_REDUCER_PATH,
  baseQuery: unifiedFieldsBaseQuery,
  keepUnusedDataFor: 5 * 60,
  refetchOnFocus: false,
  serializeQueryArgs: (args) => {
    const { payload } = extractQueryOptions(args.queryArgs);
    return defaultSerializeQueryArgs({ ...args, queryArgs: payload });
  },
  tagTypes: [TagType.UnifiedField, ...Object.values(Tags)],
  extractRehydrationInfo: extractRtkQueryRehydrationInfo,
  endpoints: () => ({}),
});
